import React, { Fragment, useState, useEffect } from 'react';
import Slider from 'react-slick';

import { ACCESSORIES_LINK, SEE_ALL_LINK, STORES_LINK, STORES_NOTES, SHARES } from './constants';

import './FooterSquidGame.scss';

export const FooterSquidGame = ({ baseImgUrl }) => {
  const [position, setPosition] = useState('fixed');

  const accessoriesSetting = {
    infinite: true,
    dots: true,
    speed: 500,
    arrows: false,
    variableWidth: false,
    adaptiveHeight: true,
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.querySelector('.base-squid-game')?.offsetHeight || 0;

      if (scrollTop + windowHeight >= documentHeight) {
        setPosition('static');
      } else {
        setPosition('fixed');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <section className="footer-squid-game__case" id="case">
        <div className="base-squid-game__container">
          <div className="footer-squid-game__case__inner">
            <div className="footer-squid-game__case__left">
              <div className="footer-squid-game__case__thumb">
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet={`${baseImgUrl}/case/case-thumb_pc.webp`}
                  />
                  <img
                    alt="Pink Guard and Coffin"
                    loading="lazy"
                    src={`${baseImgUrl}/case/case-thumb_sp.webp`}
                  />
                </picture>
              </div>

              <h2 className="footer-squid-game__case__title">
                <span>Original</span>
                <span>Set Case</span>
              </h2>
            </div>

            <div className="footer-squid-game__case__right">
              <p className="footer-squid-game__case__text">
                Each frame in the collection comes with a spectacle case modeled after the symbolic
                “coffin” that carries the fallen players’ glasses—darkly humorous and distinctly
                memorable. Also included: a practical spectacle pouch that doubles as a lens cloth.
              </p>
              <div className="footer-squid-game__case__img">
                <img
                  alt="Original Set Case"
                  loading="lazy"
                  src={`${baseImgUrl}/case/case-img.webp`}
                />
              </div>
            </div>
          </div>

          <div className="footer-squid-game__case__pg">
            <img
              alt="pink guard"
              data-aos="fade-up"
              loading="lazy"
              src={`${baseImgUrl}/case/pink-guard.webp`}
            />
          </div>
        </div>
      </section>

      <section className="footer-squid-game__accessories" id="accessories">
        <div className="base-squid-game__container base-squid-game__container--lg">
          <h2 className="base-squid-game__title" data-aos="fade-up">
            <span>Collaboration Exclusive</span>
            <strong> ACCESSORIES</strong>
            <img alt="ACCESSORIES" loading="lazy" src={`${baseImgUrl}/accessories/title.svg`} />
          </h2>

          <div className="footer-squid-game__accessories__card" data-aos="fade-up">
            <Slider {...accessoriesSetting} className="footer-squid-game__accessories__slider">
              {[...Array(3)].map((_, index) => (
                <li key={index}>
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet={`${baseImgUrl}/accessories/accessory-slide-0${index + 1}_pc.webp`}
                    />
                    <img
                      alt="456 SMARTPHONE GRIP"
                      loading="lazy"
                      srcSet={`${baseImgUrl}/accessories/accessory-slide-0${index + 1}_sp.webp`}
                    />
                  </picture>
                </li>
              ))}
            </Slider>

            <div className="footer-squid-game__accessories__details">
              <h3 className="footer-squid-game__accessories__details-title">
                <span>456</span>
                <span>SMARTPHONE GRIP</span>
              </h3>

              <div className="footer-squid-game__accessories__details-product-number-and-price">
                <p className="footer-squid-game__accessories__details-product-number">SG-GRIP-5S</p>
                <p className="footer-squid-game__accessories__details-price">S$18</p>
              </div>

              <p className="footer-squid-game__accessories__details-text">
                A mirror grip that attaches to your phone, adorned with the iconic '456' worn by the
                lead character. Now you can enjoy watching Netflix on your smartphone comfortably!
              </p>

              <img
                alt="456 SMARTPHONE GRIP"
                className="footer-squid-game__accessories__details-img"
                loading="lazy"
                src={`${baseImgUrl}/accessories/accessory-img.webp`}
              />

              <div className="footer-squid-game__accessories__details-btn">
                <a
                  className="base-squid-game__btn base-squid-game__btn--pink"
                  href={ACCESSORIES_LINK}
                >
                  ONLINE STORE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="footer-squid-game__stores" id="stores">
        <div className="footer-squid-game__stores__btn">
          <a className="base-squid-game__btn base-squid-game__btn--red" href={SEE_ALL_LINK}>
            See All Items
          </a>

          <a className="base-squid-game__btn base-squid-game__btn--red" href={STORES_LINK}>
            Search For Nearest OWNDAYS Stores
          </a>
        </div>

        <ul className="footer-squid-game__stores__notes">
          {STORES_NOTES.map((text, index) => (
            <li key={`store-squid-game-${index}`}>{text}</li>
          ))}
        </ul>

        <div className="footer-squid-game__stores__pg">
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={`${baseImgUrl}/accessories/pink-guard_pc.webp`}
            />
            <img
              alt="pink guard"
              data-aos="fade-up"
              loading="lazy"
              src={`${baseImgUrl}/accessories/pink-guards_sp.webp`}
            />
          </picture>
        </div>
      </section>

      <section className="footer-squid-game__share">
        <div className="footer-squid-game__share__layout">
          <h2 className="footer-squid-game__share__title">
            <span>SHARE</span>
            <img alt="Share" loading="lazy" src={`${baseImgUrl}/share.svg`} />
          </h2>

          <ul className="footer-squid-game__share__list">
            {SHARES.map(({ link, className }, index) => (
              <li key={index}>
                <a href={link} rel="noopener noreferrer" target="_blank">
                  <i aria-hidden="true" className={`fab ${className}`}></i>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <p className="footer-squid-game__share__copyright">
          SQUID GAME ™/© Netflix. Used with Permission.
        </p>
      </section>

      <nav className="footer-squid-game__navs-sticky">
        <div
          className="footer-squid-game__navs-sticky__inner"
          style={{
            position,
          }}
        >
          <div className="footer-squid-game__navs-sticky__container">
            <p className="footer-squid-game__navs-sticky__title">
              <i>
                <span>Pre-order online now</span>
              </i>
              <small>Until 9:59 Fri 27 June</small>
            </p>

            <a
              className="footer-squid-game__navs-sticky__btn base-squid-game__btn base-squid-game__btn--pink"
              href="#lineup"
            >
              LINEUP
            </a>

            <div className="footer-squid-game__navs-sticky__desc">
              <p className="footer-squid-game__navs-sticky__desc--sp">
                <span>Pre-Order Exclusive: Receive a</span>
                <span>Complimentary Collaboration Metal Charm!</span>
              </p>
              <p className="footer-squid-game__navs-sticky__desc--pc">
                <span>Pre-Order Exclusive: </span>
                <span>Receive a Complimentary Collaboration Metal Charm!</span>
              </p>
              <a href="#novelty">More Details</a>
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};
